import React from 'react';
import { SparklesIcon } from 'lucide-react';
import { SectionHeading } from '../ui/SectionHeading';
import { Reveal } from '../ui/Reveal';
import { TRANSMUTACION } from '../../data/retiro';
export function Transmutacion() {
  return <section className="relative w-full overflow-hidden px-5 py-24 sm:px-8 sm:py-32" style={{
    backgroundColor: 'var(--ink)'
  }} data-id="element-183">
      <div className="mx-auto max-w-5xl" data-id="element-184">
        <SectionHeading eyebrow="La Gran Transmutación" title="La Alquimia de la Magia Balinesa" subtitle="Los cuatro elementos se integran en un proceso de transformación alquímica que activa tu poder personal más profundo." light data-id="element-185" />

        <div className="mt-16 grid gap-5 sm:grid-cols-2" data-id="element-186">
          {TRANSMUTACION.map((item, i) => <Reveal key={i} delay={i * 0.08} data-id="element-187">
              <div className="flex h-full items-start gap-4 rounded-2xl border border-white/10 bg-white/[0.03] p-6" data-id="element-188">
                <SparklesIcon className="mt-0.5 h-5 w-5 shrink-0" style={{
              color: 'var(--jasmine)'
            }} data-id="element-189" />
                <p className="text-sm leading-relaxed text-white/80" data-id="element-190">{item}</p>
              </div>
            </Reveal>)}
        </div>
      </div>
    </section>;
}